import { ReactNode } from 'react';

import { IconAngleRight, IconClockOutline } from '@iwoca/icons';
import { Pill, Text } from '@iwoca/orion';
import { maintainStateKey } from '@iwRouter/LocationHelper';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';

export type TFundingRequirementStatus =
    'OPTIONAL' | 'REQUIRED' | 'COMPLETED' | 'ERROR' | 'PENDING';

type TRequirementItemProps = {
    title: ReactNode;
    estimatedTime: ReactNode;
    href: string;
    status: TFundingRequirementStatus;
    completedView?: ReactNode;
};

export const RequirementItem = ({
    title,
    estimatedTime,
    href,
    status,
    completedView
}: TRequirementItemProps) => {
    const { search } = useLocation();
    const showCompletedView = status === 'COMPLETED' || status === 'PENDING';

    const requirementItemContent = (
        <div className="flex items-center justify-between gap-l border-b border-secondary-90 p-xl hover:bg-structure-95">
            {showCompletedView ? (
                <div className="grow">{completedView}</div>
            ) : (
                <Text className="text-action-primary flex items-center gap-s text-m font-med text-primary-40">
                    {title}
                    <IconAngleRight className="text-l" />
                </Text>
            )}
            {showCompletedView ? (
                <>
                    {status === 'PENDING' ? (
                        <Pill variant="london">
                            <FormattedMessage
                                id="_.funding_requirements.requirement_item.pending"
                                defaultMessage="Pending"
                            />
                        </Pill>
                    ) : (
                        <Pill variant="green">
                            <FormattedMessage
                                id="_.funding_requirements.requirement_item.completed"
                                defaultMessage="Completed"
                            />
                        </Pill>
                    )}
                </>
            ) : (
                <span className="flex shrink-0 items-center gap-s text-s font-reg text-structure-40">
                    {estimatedTime}
                    <IconClockOutline className="text-s" />
                </span>
            )}
        </div>
    );

    return showCompletedView ? (
        requirementItemContent
    ) : (
        <Link to={maintainStateKey({ pathname: href, search })}>
            {requirementItemContent}
        </Link>
    );
};
